import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import * as React from "react";
import { Icon } from "~/components/icon";
import { cn } from "~/lib/utils";

const RadioGroupRoot = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-2", className)}
      {...props}
      ref={ref}
    />
  );
});

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <div className="inline-flex group">
      <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(
          "relative aspect-square h-6 w-6 rounded-full border-2 border-greyscale-50 hover:border-greyscale-60 text-primary group-focus-within:border-primary-500 group-focus-within:outline group-focus-within:outline-2 group-focus-within:outline-offset-2 group-focus-within:outline-focus disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary-500 transition-colors",
          className,
        )}
        {...props}
      >
        <RadioGroupPrimitive.Indicator className="flex items-center justify-center text-current absolute inset-0">
          <Icon name="radio-selected-WOC" className="w-6 h-6" />
        </RadioGroupPrimitive.Indicator>
      </RadioGroupPrimitive.Item>
    </div>
  );
});

export const RadioGroup = Object.assign(RadioGroupRoot, {
  Item: RadioGroupItem,
});
